import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Form from '../../../adminpanel/components/commonComponents/Form.v2';
import { getData, resetAlfredQuestions, resetTool, setData } from '../../actions/index';

const AllDashboards = ({ authData, getData, dataSet, setData, allDashboards, dataResult }) => {

  allDashboards.dashbordGroups.forEach(dashboard => {
    const id = dashboard.toolId;
    const dataSet = dataResult.find(res => res.toolId === id);
    let name = '';
    if (dataSet) {
      name = dataSet.name
    }
    if (dashboard.type === "global") {
      name = "Global";
    }
    dashboard.dataSet = name;
  })

  const sortList = (type, array) => {
    const sortedData = [...array];
    sortedData.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameb = b.name.toLowerCase();
      if (nameA < nameb) {
        return type === "ascending" ? -1 : 1;
      }
      if (nameA > nameb) {
        return type === "ascending" ? 1 : -1;
      }
      return 0
    });
    return sortedData;
  }

  const startList = sortList('ascending', allDashboards.dashbordGroups);

  const [search, setSearch] = useState('');
  const [dashboardData, setDashboardData] = useState(startList);
  const [dropDownVal, setdropDownVal] = useState("");
  const [errorMessage, setErrorMessage] = useState(false);
  useEffect(() => {
    if (authData.length == 0) {
      getData(authData.userId);
    }
  }, [])

  useEffect(() => {
  }, [dashboardData])

  const formVar = {
    "filterByDatasetName": {
      "name": "filterByDatasetName",
      "type": "dropdown",
      "text_value": dropDownVal,
      "options": [
        { "name": "All Datasets", "value": "default", "style": 'alert alert-primary' },
      ],
      "requiredFlag": true,
    }
  }

  const unique = ["Global", ... new Set(dataResult.map(item => item.name))];
  unique.forEach(element => {
    element === "Global"
      ? formVar['filterByDatasetName'].options.push({ "name": element, "value": element, "style": 'alert alert-info' })
      : formVar['filterByDatasetName'].options.push({ "name": element, "value": element })
  })

  const handleChange = (e) => {
    setdropDownVal(e.target.value);
    handleDatasetSelection(e.target.value);
  }

  const handleDatasetSelection = (datasetName) => {
    if (datasetName !== 'default') {
      const datasetDashboardList = startList.filter(dashboard => (dashboard.dataSet.toLowerCase().includes(datasetName.toLowerCase())));
      if (datasetDashboardList.length >= 1) {
        errorMessage === true ? setErrorMessage(!errorMessage) : null;
        setDashboardData(datasetDashboardList);
      } else {
        errorMessage === true ? setErrorMessage(errorMessage) : setErrorMessage(!errorMessage);
      }
    } else {
      errorMessage === true ? setErrorMessage(!errorMessage) : null;
      setDashboardData(startList);
    }
  }

  const handleClick = (value) => {
    const { idDashboard } = value;
    let url = `/pinboard?dashboard_id=${idDashboard}&toolId=${value.toolId}`;
    if(value.type=="global")
      url = `/globaldashboards?dashboard_id=${idDashboard}`;

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('target', `_blank`);
    link.click();

  }

  // if (!dataSet.toolId || dataSet.toolId != value.toolId) {
  //   let params = {
  //     siteId: value.siteId, toolId: value.toolId, filterType: 'all',
  //     propValues: null, filterValues: null, type: null, userId: authData.userId
  //   }
  //   CallAPI("GET", '/app/initialRequest', null, params, 0, function (res) {
  //     var userFeature = res.userFeature;
  //     var dateObject = res.dateTime[0];
  //     var final_data = {
  //       endDate: dateObject.dashboardEndTime,
  //       startDate: dateObject.dashboardStartTime,
  //       endTime: dateObject.endTime,
  //       startTime: dateObject.startTime,
  //       userFeature: userFeature,
  //       dashbordGroups: res.dashbordGroups,
  //       userDBSetting: res.userDBSetting,
  //       summarizationDetails: res.summarizationDetails,
  //       getAllUsers: res.getAllUsers,
  //       getNotification: res.getNotification,
  //       getuserprofile: res.getuserprofile,
  //       chartDefault: res.chartDefault,
  //       alfred: { intent: res.intent, metric: res.metric, property: res.property, questions: res.questions, location: res.location, chart_array: res.chart },
  //       ...value
  //     }
  //     setData(final_data)
  //     window.localStorage.setItem('Dataset', JSON.stringify(value));
  //     window.localStorage.setItem('dashboardConfigKey', {});
  //   }, authData)
  // }

  // const handleSort = (type, event) => {
  //   event.preventDefault();
  //   const sortedArray = sortList(type, dashboardData);
  //   setDashboardData(sortedArray);
  // }

  const handleSearch = (event) => {
    const target = event.target;
    setSearch(target.value);
    if (target.value === '') {
      errorMessage === true ? setErrorMessage(!errorMessage) : setErrorMessage(errorMessage)
      setDashboardData(startList);
      setdropDownVal("default");
    } else {
      const filteredList = startList.filter(dashboard => (dashboard.name.toLowerCase().startsWith(target.value.toLowerCase()) || dashboard.dataSet.toLowerCase().startsWith(target.value.toLowerCase())));
      if (filteredList.length >= 1) {
        setDashboardData(filteredList);
        errorMessage === true ? setErrorMessage(!errorMessage) : setErrorMessage(errorMessage);
      } else {
        errorMessage === true ? setErrorMessage(errorMessage) : setErrorMessage(!errorMessage);
      }
    }
  }

  const boxData = dashboardData.map((eachValue) =>
    (<div className="col-sm-6 col-lg-4 col-xl-3 mg-t-10" id={`dashboard_${eachValue.idDashboard}`} key={eachValue.idDashboard} style={{ cursor: "pointer" }}>
      <div className="media media-folder" onClick={() => handleClick(eachValue)}>
        <i className='fas fa-th-large desc-btn db-icon'></i>
        <div className="media-body" id={`dashboard_dataset_${eachValue.idDashboard}`}>
          <h6>
            <a className="link-02">{eachValue.name} ({eachValue.dataSet})</a>
          </h6>
        </div>
        <i title='Open In New Tab' className='fas fa-external-link-alt desc-btn' data-toggle="tooltip" data-placement="bottom"></i>
      </div>
    </div>)
  )

  return (<>
    <div className="d-flex">
      <div>
        <div className="search-form">
          <input type="search" className="form-control" placeholder="Search" value={search} onChange={handleSearch} />
          <button className="btn btn-white" type="button"><i className="fa fa-search" aria-hidden="true"></i></button>
        </div>
        {/* <div className="dropdown mg-l-10">
          <button className="btn btn-white  dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Sort
        </button>
          <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a className="dropdown-item" href="#" onClick={(event) => { handleSort('ascending', event) }}>Ascending</a>
            <a className="dropdown-item" href="#" onClick={(event) => { handleSort('descending', event) }}>Descending</a>
          </div>
        </div> */}
      </div>
      <div className="col-md-2">
        <Form label_array={formVar} handle_form_drop_down={handleChange} />
      </div>
    </div>
    <div className="pd-x-0" id="handle_content">
      <div className='box-no-padding mainCont'>
        {
          errorMessage
            ? <h5 className="text-center mg-100">No Dashboards available for the selected Dataset.</h5>
            : <div className="row row-xs">{boxData}</div>
        }
      </div>
    </div>
  </>
  )
}

function mapStateToProps(state) {
  return {
    authData: state.dataSet.authData,
    dataResult: state.dataSet.dataResult,
    dataSet: state.dataSet.dataSet,
    allDashboards: state.dataSet.allDashboards || {}
  }
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setData, getData, resetTool, resetAlfredQuestions
  }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(AllDashboards);
